import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Typography} from "@mui/material";
import CustomPagination from "../../shared/utils/CustomPagination";

const PayoutTable = () => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const payoutRows = [
        { id: 1, date: "1-12-2024", description: "Payout requested", amountRequested: "₹ 15,000", refunds: "+ ₹ 1,500", amount: "₹ 26,500" },
        { id: 2, date: "31-11-2024", description: "Requests", amountRequested: "₹ 12,000", refunds: "- ₹ 1,500", amount: "₹ 10,500" },
        { id: 3, date: "16-11-2024", description: "Payout requested", amountRequested: "₹ 15,000", refunds: "+ ₹ 1,500", amount: "₹ 16,500" },
        { id: 4, date: "1-11-2024", description: "Requests", amountRequested: "₹ 12,000", refunds: "- ₹ 1,500", amount: "₹ 10,500" },
        { id: 5, date: "31-10-2024", description: "Requests", amountRequested: "₹ 12,000", refunds: "- ₹ 1,500", amount: "₹ 10,500" },
    ];

    const payoutColumns = [
        {
            field: "date",
            headerName: "Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" my={2}>{params.value}</Typography>,
        },
        {
            field: "description",
            headerName: "Description",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "amountRequested",
            headerName: "Amount Requested",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "refunds",
            headerName: "Refunds",
            flex: 1,
            renderCell: (params) => (
                <Typography variant="body2" style={{ color: params.value.includes("+") ? "#00BD16" : "#BD0000" }}>
                    {params.value}
                </Typography>
            ),
        },
        {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
    ];

    return (
       
            <DataGrid
                rows={payoutRows}
                columns={payoutColumns}
                pagination
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={[10]}
                slots={{
                    pagination: () => (
                        <CustomPagination
                            paginationModel={paginationModel}
                            setPaginationModel={setPaginationModel}
                            totalRows={payoutRows.length || 10}
                        />
                    ),
                }}
            />
     
    );
};

export default PayoutTable;
